import React from "react";
import { List } from "semantic-ui-react";
import {
  URL_DOCUMENTO_TERMINOS_DATOS_PERSONALES,
  MSG_VER_TERMINOS_CONDICIONES,
} from "../../../app/infrastructure/appConstants";

const ListaDocumentoTerminosDatosPersonales = () => {
  return (
    <>
      <List>
        <List.Item>
          <List.Icon name="caret right" color="blue" />
          <List.Content>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={URL_DOCUMENTO_TERMINOS_DATOS_PERSONALES}
            >
              {MSG_VER_TERMINOS_CONDICIONES}
            </a>
          </List.Content>
        </List.Item>
      </List>
    </>
  );
};

export default ListaDocumentoTerminosDatosPersonales;
